import { Box, Grid, Stack } from '@mui/material';
import { format } from 'date-fns';
import { CalendarBlank, ClockOutline } from 'mdi-material-ui';
import { VigoTypography } from 'src/@vigo/vigo-typography';

interface StatusEtaProps {
  liveEta: string;
  etaWindow?: string;
  noPadding?: boolean;
  sx?: any;
  noPaddingBlock?: boolean;
}

const EtaSection = ({ liveEta, etaWindow, sx }: StatusEtaProps) => {
  return (
    <Stack direction="row" sx={sx}>
      <Box
        sx={{
          backgroundColor: '#2EA836',
          color: '#fff',
          borderRadius: '20px',
          fontSize: '1rem',
          fontWeight: 'bold',
          textTransform: 'capitalize',
          paddingRight: '15px',
          paddingLeft: '15px',
          paddingTop: '7px',
          paddingBottom: '5px',
          zIndex: '1'
        }}>
        ETA
      </Box>
      <Box
        sx={{
          backgroundColor: '#32CD32',
          color: '#fff',
          borderRadius: '20px',
          fontSize: '1rem',
          fontWeight: 'bold',
          textTransform: 'capitalize',
          paddingRight: '15px',
          paddingLeft: '40px',
          paddingTop: '7px',
          paddingBottom: '5px',
          marginLeft: '-30px'
        }}>
        <Stack direction="row" gap={4}>
          <Stack direction="row" gap={1}>
            <CalendarBlank />
            <VigoTypography
              value={format(new Date(liveEta ?? ''), 'dd/MM/yy')}
              sx={{ color: '#fff', fontWeight: 'bold', fontSize: '1rem' }}
              disableTranslation
            />
          </Stack>
          <Stack direction="row" gap={1}>
            <ClockOutline />
            <VigoTypography
              value={etaWindow ?? format(new Date(liveEta ?? ''), 'HH:mm')}
              sx={{ color: '#fff', fontWeight: 'bold', fontSize: '1rem' }}
              disableTranslation
            />
          </Stack>
        </Stack>
      </Box>
    </Stack>
  );
};

const StatusEta = ({ liveEta, etaWindow, noPadding, sx, noPaddingBlock }: StatusEtaProps) => {
  return (
    <Stack
      direction="row"
      gap="10px"
      sx={
        noPadding
          ? { width: '100%', bgcolor: theme => (theme.palette.mode === 'dark' ? '#1d1d1d' : 'white'), p: 2 }
          : { width: '100%', bgcolor: theme => (theme.palette.mode === 'dark' ? '#1d1d1d' : 'white') }
      }>
      <Stack
        direction="column"
        sx={noPadding ? { width: '100%' } : { paddingBlock: noPaddingBlock ? undefined : '5px 20px', width: '100%' }}>
        <Stack direction="row">
          <Grid container>
            <Grid item xs={10}>
              <EtaSection {...{ liveEta, etaWindow, sx }} />
            </Grid>
          </Grid>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default StatusEta;
